import classNames from 'classnames';

import styles from './Collapse.module.scss';

export interface ICollapseProps {
    on: boolean;
    children: React.ReactNode;
}

const Collapse = ({on = false, children}: ICollapseProps) => {
    return (
        <div className={classNames(styles.container, {[styles.hide]: !on})}>
            {children}
        </div>
    );
};

export default Collapse;
